export const AMPLITUDE_EVENT_NAMES = {
    regoEntered: "trace in banner rego entered",
    stateSelected: "trade in banner state entered",
    yearSelected: "trade in banner year entered",
    variantSelected: "trade in banner variant selected",
    odoEntered: "trade in banner odometer entered",
    mmyOpened: "trade in banner mmvy opened"
};

export const TRADE_IN_BANNER_PROPERTY = {
    event: "custom_event",
    eventLabel: "trade_in_banner",
    eventCategory: "Cars24_detail_page"
};

export const TRADE_IN_BANNER_ESTIMATE_PROPERTY = {
    event: "custom_event",
    eventLabel: "trade_in_banner_estimated_valuation",
    eventCategory: "Cars24_detail_page"
};

export const TRADE_IN_GA_EVENTS = {
    regoEntered: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "rego_entered",
        eventLabel: "trade_in_banner"
    },
    stateSelected: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "state_selected",
        eventLabel: "trade_in_banner"
    },
    yearSelected: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "year_selected",
        eventLabel: "trade_in_banner"
    },
    odoEntered: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "odo_entered",
        eventLabel: "trade_in_banner"
    },
    valuationClicked: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "get_valuation_clicked",
        eventLabel: "trade_in_banner"
    },
    mmyOpened: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "mmy_opened",
        eventLabel: "trade_in_banner"
    },
    variantSelected: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page"
    }

};
